import { fromEvent } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter } from 'rxjs/operators';
import { Renderer2 } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

const MIN_WIDTH = 1280;
const BREADCRUMB_HEIGHT = 45;
const WORKSPACE_SEARCH_HEADER = 140;
const NAVBAR_HEIGHT = 50;

export const ID_PAGE = 'id-page';
export const ID_SIDEBAR = 'id-sidebar';
export const ID_SESSION_NOTIFICATION = 'id-session-notification';
export const ID_DASHBOARD_LAYOUT = 'id-dashboard-layout';
export const ID_DASHBOARD_LAYOUT_CONTAINER = 'id-dashboard-layout-container';
export const ID_TEMPLATE_EDITOR = 'id-template-editor';
export const ID_GLOBAL_MEASURE_CHECK = 'id-global-measure-check';
export const ID_TEMPLATE_SIDEBAR = 'id-template-sidebar';
export const ID_WORKSPACE_SEARCH = 'id-workspace-search';

export abstract class ResolutionChecker {
  private clientWidth: number = null;
  private clientHeight: number = null;

  protected constructor(public renderer2: Renderer2,
                        public router: Router) {
    this.handleResolution();

    fromEvent(window, 'resize').pipe(
      debounceTime(150)
    ).subscribe(t => {
      this.handleResolution();
    });


    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      distinctUntilChanged(),
      debounceTime(150)
    ).subscribe(() => {
      this.handleResolution();
    });
  }

  get supportedResolution() {
    return this.clientWidth >= MIN_WIDTH;
  }

  static getScaleValue(clientWidth: number) {
    return (clientWidth * 0.406) / 520
  }

  static applyStyle(renderer2: Renderer2, container: HTMLElement, scale: number) {
    renderer2.setStyle(container, 'transform', `scale(${scale.toString()})`);
    renderer2.setStyle(container, 'transform-origin', 'left top');
    renderer2.setStyle(container, 'min-width', '1280px');
  }

  public handleResolution() {
    this.clientWidth = document.documentElement.clientWidth;
    this.clientHeight = document.documentElement?.clientHeight;

    if (this.supportedResolution) {
      this.removeStyle();
    } else {
      this.setStyle();
    }
  }

  public initializeResolution() {
    this.handleResolution();
  }

  // private setWidth(id: string, value: number) {
  //   const element = document.getElementById(id);
  //   if (element) {
  //     this.renderer2.setStyle(element, 'width', value + 'px');
  //   }
  // }

  abstract setResolutionScaled(scaled: boolean);

  private setStyle() {
    const height = (MIN_WIDTH * this.clientHeight / this.clientWidth) - NAVBAR_HEIGHT;
    const scale = ResolutionChecker.getScaleValue(this.clientWidth);
    const container = document.getElementById(ID_DASHBOARD_LAYOUT);
    if (container) {
      ResolutionChecker.applyStyle(this.renderer2, container, scale);
    }
    // this.setWidth(ID_SIDEBAR_DETAIL, 500);


    this.setHeight(ID_SIDEBAR, (height));
    this.setHeight(ID_SESSION_NOTIFICATION, (height));
    this.setHeight(ID_DASHBOARD_LAYOUT_CONTAINER, (height));
    this.setHeight(ID_PAGE, (height - BREADCRUMB_HEIGHT));
    this.setHeight(ID_TEMPLATE_EDITOR, (height - BREADCRUMB_HEIGHT));
    this.setHeight(ID_GLOBAL_MEASURE_CHECK, (height - BREADCRUMB_HEIGHT));
    this.setHeight(ID_TEMPLATE_SIDEBAR, (height - BREADCRUMB_HEIGHT));
    this.setHeight(ID_WORKSPACE_SEARCH, (height - BREADCRUMB_HEIGHT - WORKSPACE_SEARCH_HEADER));

  }

  // private removeWidth(id: string) {
  //   const element = document.getElementById(id);
  //   if (element) {
  //     this.renderer2.removeStyle(element, 'width');
  //   }
  // }

  private setHeight(id: string, value: number) {
    const element = document.getElementById(id);
    if (element) {
      this.renderer2.setStyle(element, 'height', value + 'px');
    }
  }

  private removeHeight(id: string) {
    const element = document.getElementById(id);
    if (element) {
      this.renderer2.removeStyle(element, 'height');
    }
  }

  private removeStyle() {
    const dashboardLayout = document.getElementById(ID_DASHBOARD_LAYOUT);
    if (dashboardLayout !== null) {
      this.renderer2.removeStyle(dashboardLayout, 'transform');
      this.renderer2.removeStyle(dashboardLayout, 'min-width');
      this.renderer2.removeStyle(dashboardLayout, 'transform-origin');
    }

    this.removeHeight(ID_SIDEBAR);
    this.removeHeight(ID_SESSION_NOTIFICATION);
    this.removeHeight(ID_DASHBOARD_LAYOUT_CONTAINER);
    this.removeHeight(ID_PAGE);
    this.removeHeight(ID_GLOBAL_MEASURE_CHECK);
    // this.removeWidth(ID_SIDEBAR_DETAIL);
    // this.removeHeight(ID_TEMPLATE_EDITOR);
    // this.removeHeight(ID_TEMPLATE_SIDEBAR);
    this.setHeight(ID_TEMPLATE_EDITOR, this.clientHeight - BREADCRUMB_HEIGHT - NAVBAR_HEIGHT);
    this.setHeight(ID_TEMPLATE_SIDEBAR, this.clientHeight - BREADCRUMB_HEIGHT - NAVBAR_HEIGHT);
    this.setHeight(ID_WORKSPACE_SEARCH, (this.clientHeight - BREADCRUMB_HEIGHT - WORKSPACE_SEARCH_HEADER));
  }

}
